// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"293":"component---src-pages-index-js","432":"component---src-pages-about-js"}[chunkId] + "-" + {"293":"d5e76466aa7b02a2d4cc","432":"71afd30ce240615a0539"}[chunkId] + ".js";
};